import RentalProperties from "./RentalProperties.vue";
import RentalUnits from "./RentalUnits.vue";
import RentalOwners from "./RentalOwners.vue";
import LeaseRents from "./LeaseRents.vue";
import AssociationOwners from "./AssociationOwners.vue";
import AssociationFiles from "./AssociationFiles.vue";
import Vendors from "./Vendors.vue";
import VendorTransactions from "./VendorTransactions.vue";
import Bills from "./Bills.vue";
import BuildiumBills from "./BuildiumBills.vue";
import DextBillsDownload from "./DextBillsDownload.vue";
import Associations from './Associations.vue';
import ChartOfAccounts from "./ChartOfAccounts.vue";
import StatementMerge from "./StatementMerge.vue";

module.exports = [
    {path: '/buildium/rental-properties', component: RentalProperties, meta: {title: 'Rental Properties'}},
    {path: '/buildium/rental-units', component: RentalUnits, meta: {title: 'Rental Units'}},
    {path: '/buildium/rental-owners', component: RentalOwners, meta: {title: 'Rental Owners'}},
    {path: '/buildium/rental-owners', component: RentalOwners, meta: {title: 'Rental Owners'}},
    {path: '/buildium/lease-rents', component: LeaseRents, meta: {title: 'Lease Rents'}},
    {path: '/buildium/association-owners', component: AssociationOwners, meta: {title: 'Association Owners'}},
    {path: '/buildium/association-files', component: AssociationFiles, meta: {title: 'Association Files'}},
    {path: '/buildium/vendors', component: Vendors, meta: {title: 'Vendors'}},
    {path: '/buildium/vendors/:id/transactions', component: VendorTransactions, meta: {title: 'Vendor Transactions'}},
    {path: '/buildium/bills', component: Bills, meta: {title: 'Bills'}},
    {path: '/buildium/buildium-bills', component: BuildiumBills, meta: {title: 'BuildiumBills'}},
    {path: '/buildium/dext-bills-download', component: DextBillsDownload, meta: { title: 'Dext Bills Download' } },
    {path: '/buildium/associations', component: Associations, meta: { title: 'Associations' } },
    {path: '/buildium/chart-of-accounts', component: ChartOfAccounts, meta: { title: 'ChartOfAccounts' } },
    {path: '/buildium/statement-merge', component: StatementMerge, meta: { title: 'StatementMerge' } },
]